import { render, staticRenderFns } from "./DispositivosExtendidoActividad.vue?vue&type=template&id=57cde745&scoped=true&"
import script from "./DispositivosExtendidoActividad.vue?vue&type=script&lang=ts&"
export * from "./DispositivosExtendidoActividad.vue?vue&type=script&lang=ts&"
import style0 from "./DispositivosExtendidoActividad.vue?vue&type=style&index=0&id=57cde745&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cde745",
  null
  
)

export default component.exports